export const RESOURCE_TYPE_NEXTGEN_BOARD = 'NEXTGEN_BOARD';
export const RESOURCE_TYPE_NEXTGEN_BOARD_CUSTOM_FILTERS = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
export const RESOURCE_TYPE_NEXTGEN_BOARD_RELAY = 'NEXTGEN_BOARD_RELAY';
export const RESOURCE_TYPE_NEXTGEN_BOARD_FILTER_REFINEMENT = 'NEXTGEN_BOARD_FILTER_REFINEMENT';
